module.exports = __webpack_public_path__ + "static/qh_2.135bcda6.jpg";